import { useMutation } from '@tanstack/react-query';
import { fromPairs, map } from 'lodash-es';
import { apiClient, getEndpoints } from '../../common';
import { reportsQueryKeyFactory } from '../report';

interface IReorderWidgetParams {
	data: {
		widgetIds: string[];
		from: number;
		to: number;
	};
	reportId: string;
}

export function reorderWidgetsHelper<T>(
	widgets: T[],
	from: number,
	to: number
) {
	const item = widgets[from];
	widgets.splice(from, 1);
	widgets.splice(to, 0, item);
	return widgets;
}

export function useReorderWidgets() {
	const mutationFn = async ({
		data: { widgetIds, from, to },
		reportId,
	}: IReorderWidgetParams) => {
		widgetIds = reorderWidgetsHelper<string>(widgetIds, from, to);

		const widgetOrder = fromPairs(map(widgetIds, (id, order) => [id, order]));

		const baseUrl = getEndpoints(reportsQueryKeyFactory.namespace).byId(
			reportId
		);

		const url = `${baseUrl}reorder`;

		await apiClient.post(url, { widget_order: widgetOrder });
	};

	return useMutation({
		mutationFn,
	});
}
